<template>
    <div>
        <Calendar :attributes='events' is-expanded>
            <div slot='event-template' slot-scope='{ customData }'>
                <b class="mt-1">{{ customData.event.title }}</b>
                <p class="py-nomple">{{ customData.event.venue }}<br/><b>{{ customData.event.cost }}</b></p>
                <a :href="customData.event.link" :title="`Find out more about ${customData.event.title}`" class="inline-block bg-pink hover:bg-blue px-2 text-white hover:text-white no-underline leading-normal capitalize text-xs font-400 tracking-wide rounded-none border-none">Read more</a>
            </div>
        </Calendar>
    </div>
</template>

<script>
import { Calendar } from 'v-calendar';

export default {
    name: 'EventCalendar',
    components: {
        Calendar,
    },
    props: ['feed'],
    computed: {
        events() {
            return this.feed.map(event => ({
                key: event.id,
                highlight: {
                    backgroundColor: '#c40063',
                    borderColor: '#ffffff',
                    borderWidth: '2px',
                    borderStyle: 'solid',
                },
                contentStyle: {
                    color: 'white',
                },
                dates: event.date,
                customData: {
                    event,
                },
                popover: {
                    slot: 'event-template',
                    visibility: 'focus',
                    hideIndicator: true,
                }
            }));
        }
    },
}
</script>

<style>
/* Remove the local import since we're importing in the script section */
</style>


// WEBPACK FOOTER //
// web/app/themes/giles/resources/js/components/EventCalendar.vue